import React from "react";
import Header from "./components/Header/Header";
import Lead from "./components/Lead/Lead";
import Intro from "./components/Intro/Intro";
import PhotoGrid from "./components/PhotoGrid/PhotoGrid";
import Places from "./components/Places/Places";
import Cover from "./components/Cover/Cover";
import Footer from "./components/Footer/Footer";
import "./App.css";

function App() {
  return (
    <div className="page">
      <Header />
      <main>
        <Lead />
        <Intro />
        <PhotoGrid />
        <Places />
        <Cover />
      </main>
      <Footer />
    </div>
  );
}

export default App;
